import {Fragment, lazy, Suspense} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {spinnerBasicOverlayTypes, spinnerBasicSizes, spinnerBasicTypes} from '@adv-mt/mt-spinner-basic'
import IconCall from '@adv-mt/mt-svg-icons/lib/Call'
import IconCallOutline from '@adv-mt/mt-svg-icons/lib/PhoneCallOutline'

import {DESINGS_ICON, SIZES} from './config.js'

const SpinnerBasic = lazy(() => import(/* webpackChunkName: "SpinnerBasic" */ '@adv-mt/mt-spinner-basic'))

const iconProps = {
  size: 'medium',
  color: 'primary'
}

const TEST_ID = 'lead-phone-call-link'

function LeadPhoneCallLink({designIcon, isLoading, text, onClick = () => {}, size}) {
  const baseClassNames = cx('mt-LeadPhoneCall-link', `mt-LeadPhoneCall-link--${size}`)

  const IconPhone = designIcon === DESINGS_ICON.SOLID ? IconCall : IconCallOutline

  return (
    <p className={baseClassNames} onClick={onClick} data-testid={TEST_ID} aria-label={text}>
      {isLoading ? (
        <div className="mt-LeadPhoneCall-link">
          <Suspense fallback={Fragment}>
            <SpinnerBasic
              overlayType={spinnerBasicOverlayTypes.TRANSPARENT}
              size={spinnerBasicSizes.SMALL}
              type={spinnerBasicTypes.SECTION}
            />
          </Suspense>
        </div>
      ) : (
        <>
          <IconPhone {...iconProps} size={size} />
          <span className="mt-LeadPhoneCall-linkText">{text}</span>
        </>
      )}
    </p>
  )
}

LeadPhoneCallLink.displayName = 'LeadPhoneCallLink'
LeadPhoneCallLink.propTypes = {
  designIcon: PropTypes.oneOf(Object.values(DESINGS_ICON)),
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(Object.values(SIZES)),
  text: PropTypes.string.isRequired
}

export default LeadPhoneCallLink
